<template>
  <a-spin tip="数据加载中..." :spinning="loading">
    <div id="messageChart" style="height: 300px;width: 400px"></div>
  </a-spin>
</template>

<script>
import * as echarts from "echarts";
import { message_chart } from "@/api/blog";

export default {
  name: "dailyMessage",
  props: {
    blogId: null,
    dateRange: null,
  },
  data() {
    return {
      chart: null,
      loading: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  watch: {
    dateRange() {
      this.getData();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("messageChart"));
    window.onresize = () => {
      // 重新绘制
      this.chart.resize();
    };
  },
  methods: {
    createChart(refDate, messageCount, messageUser) {
      // 绘制图表
      this.chart.setOption({
        title: false,
        tooltip: { trigger: "axis" },
        legend: { data: ["消息数"] },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: { type: "category", boundaryGap: false, data: refDate },
        yAxis: { type: "value" },
        series: [
          {
            name: "消息数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: messageCount,
          },
          {
            name: "消息人数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: messageUser,
          },
        ],
      });
      this.chart.resize();
    },
    getData() {
      this.loading = true;
      // 消息 chart
      message_chart({ id: this.blogId, time_range: this.dateRange }).then(
        (res) => {
          this.loading = false;
          if (res.code === 1) {
            this.createChart(
              res.list.ref_date,
              res.list.msg_count,
              res.list.msg_user
            );
          } else {
            this.$message.warning(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style scoped></style>
